import { makeStyles } from '@material-ui/core';

export const compraProdutoFormStyles = makeStyles({
  valorTotal: {
    width: '100%',
    marginTop: 8,
    '& > label': {
      fontSize: 24,
      fontWeight: 500,
      color: '#111',
    },
  },
});
